module.exports = __webpack_public_path__ + "2485f6ee87a19e399f90ee9d37b28b1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/sarrah-vesselov.jpg
// module id = 525
// module chunks = 0